var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{attrs:{"padding":""}},[_c('div',{staticClass:"q-page-container"},[(_vm.reportUrl)?_c('object',{staticClass:"full-width",staticStyle:{"min-height":"900px"},attrs:{"data":_vm.reportUrl,"type":"application/pdf"}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }